import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";


import SubtitleSelectionMode from "./SubtitleRange/subtitleselectionmode";
import SubtitlePositionOptions from "./SubtitleRange/subtitlepositionoptions";


import imgexit from "./assets/exit.png"
import imgaccept from "./assets/accept.png"

import "./submenus.css"


class SubtitlePosition extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            toolsbar : {
                height: 26,
                items: [
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},
                    {img: imgaccept ,type:"button", disable:false,fr:"Lancer",en:"Start", nochangecolor:false, key:{key:"START", cat:"actions"}},


                    ],
            },

        }

        this.state.parameters = {
            alignment: "center",
            applyAlignment: false,
            row: 20,
            applyRow: false,
        }

        // on recherche les valeurs par défault


        if ((this.props.current >=1) && (this.props.current <= this.props.subtitles.length))
        {

            this.props.subtitles[this.props.current-1].lines.forEach(element => {
                if (element.len != 0)
                {
                    switch (element.align)
                    {
                        case 0: this.state.parameters.alignment = "left"; break;
                        case 1: this.state.parameters.alignment = "right"; break;
                        case 2: this.state.parameters.alignment = "center"; break;
                        case 3: this.state.parameters.alignment = "free"; break;
                    }
                }
                this.state.parameters.row = element.verticalPos;
            });
            
        }


        this.selectionModeRef = React.createRef();
        this.positionOptionsRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);
    }


    componentDidUpdate(prevProps)
    {

        var lastalign = this.state.parameters.alignment;
        var lastrow = this.state.parameters.row;

        
        if (prevProps.current != this.props.current)
        {
            if ((this.props.current >=1) && (this.props.current <= this.props.subtitles.length))
            {

                this.props.subtitles[this.props.current-1].lines.forEach(element => {
                    if (element.len != 0)
                    {
                        switch (element.align)
                        {
                            case 0: lastalign = "left"; break;
                            case 1: lastalign = "right"; break;
                            case 2: lastalign = "center"; break;
                            case 3: lastalign = "free"; break;
                        }
                    }


                    lastrow = element.verticalPos;
                });
                
                var parameters = this.state.parameters;
                parameters.row  = lastrow;
                parameters.alignment = lastalign;
                this.setState({parameters: parameters});
                
            }

   

        }
    }


    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "START":
                if (this.props.onaction) 
                {
                    const ret = {
                        source: "parameters",
                        action:
                        {
                            
                            type: "position",
                            parameters: this.state.parameters,
                            range: this.selectionModeRef.current.getValues(),
                        }
                    };

                    console.log("retour", ret);
                    if (this.props.onaction) this.props.onaction (ret);
                }

                
                break;


            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
        }
    }


    render()
    {
        const title = this.context.language=="fr"?"Positionnement des sous-titres":"Positions";
                return (
                    <div className="submenuMain">
                            <div className="submenuTitle">{title}</div>

                            <div className="submenuCurrentDiv">
                                <SubtitlePositionOptions ref = {this.positionOptionsRef}
                                    current = {this.props.current}
                                    alignment = {this.state.parameters.alignment}
                                    row = {this.state.parameters.row}
                                    onChange={(options) => {
                                        console.log(options);
                                        this.state.parameters = options;
                                    }}
                                />
                                <SubtitleSelectionMode ref = {this.selectionModeRef}
                                    value="current"
                                    onChange={(value) => console.log(value)}
                                    lineonly = {true}
                                    subtitles = {this.props.subtitles} 
                                    current = {this.props.current}
                                />                                
                            </div>
                            <div className="submenuBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} background={false}/>
                        </div>
                    
                    </div>
                )

    }

}

SubtitlePosition.defaultProps = 
{
    subtitles:[],
    current:1,
}

export default SubtitlePosition;



